import { render, staticRenderFns } from "./PackageRisk.vue?vue&type=template&id=0021c338&"
import script from "./PackageRisk.vue?vue&type=script&lang=js&"
export * from "./PackageRisk.vue?vue&type=script&lang=js&"
import style0 from "./PackageRisk.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PackageRisk.vue"
export default component.exports